<template>
    <div class="wizard-payment-method">
        <div class="text-center my-12">
            <h3>{{$trans.get('wizard.step2.title')}}</h3> 
        </div>
        <div class="grid-payment-method" v-if="this.getSelectedCourse.price_to_consult">
            <!-- is price to consult -->
            <div class="card-container m-auto">
                <card-courses class="h-full cursor-default" >
                    <div class="mb-5">
                        <div>
                            <h3>{{ $trans.get('wizard.step2.presencial.sele.price') }}</h3>
                            <div class="pay-description">
                                <p>{{ $trans.get('wizard.step2.presencial.sele.description') }}</p>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-primary w-full" @click="gotocontact()">
                        {{ $trans.get('wizard.step2.presencial.sele.contact')}}
                    </button>
                </card-courses>
            </div>
        </div>
        <div v-else>
            <!-- Metodos de pago cursos presenciales -->
            <div class="grid-payment-method max-w-screen-lg" :class="{ 'single': getSelectedCourse.type == 'other' }">
                <!-- if is not CFGS -->
                <div class="card-container" v-if="isNotCF()">
                    <card-courses class="h-full cursor-default" >

                        <div class="mb-5">
                            <h3>{{ $trans.get('wizard.step2.presencial.svb.price') }}</h3>
                            <p class="price">{{ totalprice | currency_symbol_front }}</p>
                                <p>{{ $trans.get('wizard.step2.presencial.svb.totalprice') }}</p>
                                <hr class="my-3">
                            <div class="pay-description">
                                <p>{{ getCourseDescription() }}</p>
                            </div>
                        </div>
                        <button class="btn btn-primary w-full" @click="selectMethod(0)">
                            {{ $trans.get('wizard.step2.presencial.totalpriceplan')}}
                        </button>
                    </card-courses>
                </div>
                <!-- if is CFGS -->
                <div class="card-container" v-if="!isNotCF()">
                    <card-courses class="h-full cursor-default" >
                        <div class="mb-5">
                            <h3>{{$trans.get('wizard.step2.presencial.pay-title1')}}</h3>
                            <p class="price">{{ totalprice | currency_symbol_front }}</p>
                            <p>{{$trans.get('wizard.step2.presencial.totalprice')}}</p>
                            <hr class="my-3">
                            <div class="pay-description">
                                <p v-if="!this.getSelectedCourse.online" v-html="$trans.get('wizard.step2.presencial.text1.p-1')"></p>
                                <p class="my-6" v-html="$trans.get('wizard.step2.presencial.text1.p-2', {
                                    date1: this.getSelectedCourse.first_date_payment,
                                    date2: this.getSelectedCourse.second_date_payment,
                                    date3: this.getSelectedCourse.third_date_payment
                                    })"></p>
                                <p v-html="$trans.get('wizard.step2.presencial.text1.p-3')"></p>
                            </div>
                        </div>
                        <button class="btn btn-primary w-full" @click="selectMethod(0)">
                            {{ $trans.get('wizard.step2.presencial.totalpriceplan')}}
                        </button>
                    </card-courses>
                </div>
                <div class="card-container" v-if="!isNotCF() && !this.getSelectedCourse.online">
                    <card-courses class="h-full cursor-default" >
                        <div class="mb-5">
                            <h3>{{$trans.get('wizard.step2.presencial.pay-title2')}}</h3>
                            <p class="price">{{ partialprice | currency_symbol_front }}</p>
                            <p>{{$trans.get('wizard.step2.presencial.monthprice')}}</p>
                            <hr class="my-3">
                            <div class="pay-description">
                                <p v-html="$trans.get('wizard.step2.presencial.text2.p-1')"></p>
                                <div v-if="this.getSelectedCourse.enrollment_price > 0 || this.getSelectedCourse.monthly_price > 0 || this.getSelectedCourse.supplementary_price > 0">
                                    <p class="mt-6" v-html="$trans.get('wizard.step2.presencial.text2.p-2')"></p>
                                    <ul style='list-style:disc;padding-left:2rem'>
                                        <li v-if="this.getSelectedCourse.enrollment_price > 0">{{$trans.get('wizard.step2.presencial.text2.li1')}} {{this.getSelectedCourse.enrollment_price | currency_symbol_front}}</li>
                                        <li v-if="this.getSelectedCourse.monthly_price > 0">{{$trans.get('wizard.step2.presencial.text2.li2')}} {{this.getSelectedCourse.monthly_price | currency_symbol_front}}</li>
                                        <li v-if="this.getSelectedCourse.supplementary_price > 0">{{$trans.get('wizard.step2.presencial.text2.li3')}} {{this.getSelectedCourse.supplementary_price | currency_symbol_front}}</li>
                                    </ul>
                                </div>
                                <p class="mt-6" v-html="$trans.get('wizard.step2.presencial.text2.p-3')"></p>
                            </div>
                        </div>
                        <button class="btn btn-primary w-full" @click="selectMethod(1)">
                            {{ $trans.get('wizard.step2.presencial.monthpriceplan')}}
                        </button>
                    </card-courses>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    computed:{
        ...mapGetters(["getSelectedCourse"]),
        totalprice(){
            var number = this.getSelectedCourse.total_price / this.getSelectedCourse.years;
            return Math.trunc(number);
        },
        partialprice(){
            var x = this.getSelectedCourse.monthly_price;
            return Math.trunc(x);
        },
    },
    methods: {
        selectMethod(val){
            switch (val) {
                case 0:
                    this.$store.commit('setSelected', { prop: 'dues', value: 'year' });
                    break;
                case 1:
                    this.$store.commit('setSelected', { prop: 'dues', value: 'month' });
                    break;
                default:
                    break;
            }
            this.$router.push({ name: 'crear-cuenta' });
        },
        isNotCF(){
           return this.getSelectedCourse.type != 'cfgs' && this.getSelectedCourse.type != 'cfgm';
        },
        toconsult(){
            return this.getSelectedCourse.price_to_consult;
        },
        gotocontact(){
           window.location.href = '/'+window.appLocale+'/'+this.$trans.get('routes.contact');
        },
        getCourseDescription() {
            const courseSlugEs = this.getSelectedCourse.slug.es;
            const courseSlugCa = this.getSelectedCourse.slug.ca;

            if (courseSlugEs === 'curso-svb-y-desa' && courseSlugCa === 'curs-svb-i-desa') {
                return this.$trans.get('wizard.step2.online.svb.description');
            } else if (courseSlugEs === 'selectividad' && courseSlugCa === 'selectivitat') {
                return this.$trans.get('wizard.step2.presencial.sele.description');
            } else {
                return '';
            }
        }
    },
}
</script>
<style lang="scss" scoped>
h3 {
    font-size: 24px;
    @media (min-width: 801px) {
        height: 62px;
    }
}
.wizard-payment-method{
    .price{
        color: #78aeda;
        font-size: 34px;
        font-weight: bold;
    }
}
.pay-description{
    p{
        font-size: 14px;
    }
}
.grid-payment-method{
    max-width: 750px;
    margin: auto;
    display: flex;
    &.single {
        justify-content: center;
    }
    @media (max-width:800px) {
        flex-direction: column;
    }
    .card-container{
        margin: 1rem;
        width:50%;
        @media (max-width:800px) {
            margin: 1rem 0;
            width:100%;
        }
    }
}
</style>
